(ns app.front.view.party.subs-req
  (:require [app.domain.group.model :as group-model]
            [app.domain.party-role.model :as role-model]
            [app.domain.requirement.model :as req-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.view.group.subs :as group-subs]
            [app.front.view.party.subs :as party-subs]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.set :as set]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::authority-group-id
  (fn [[_ phase-id]]
    (rf/subscribe [::entities/entity phase-id]))
  (fn [phase _]
    (-> phase
        group-model/get-authority-group
        :db/id)))

(rf/reg-sub ::all-party-roles
  (fn [[_ phase-id]]
    (rf/subscribe [::authority-group-id phase-id]))
  (fn [auth-group-id _]
    (set (<sub [::group-subs/available-party-roles auth-group-id]))))

(rf/reg-sub ::unlocked-party-roles
  (fn [[_ phase-id]]
    [(rf/subscribe [::all-party-roles phase-id])
     (rf/subscribe [::process/entity-process phase-id])
     (rf/subscribe [::ws-subs/applicable-party-role-ids])])
  (fn [[all-roles process applicable-role-ids] _]
    (->> all-roles
         (filter #(contains? applicable-role-ids (:db/id %)))
         (filter #(process/signal-permitted? process
                                             [:process.signal/add-party-role-requirement
                                              {:role-id (:db/id %)}]))
         set)))

(rf/reg-sub ::party-role-requirements
  (fn [[_ phase-id]]
    (rf/subscribe [::entities/entity phase-id]))
  (fn [phase _]
    (-> phase
        req-model/phase-role-requirements)))

(rf/reg-sub ::required-party-roles
  (fn [[_ phase-id]]
    (rf/subscribe [::party-role-requirements phase-id]))
  (fn [requirements _]
    (->> requirements
         (map :requirement/party-role)
         (into #{}))))

(rf/reg-sub ::unrequired-party-roles
  (fn [[_ phase-id]]
    [(rf/subscribe [::unlocked-party-roles phase-id])
     (rf/subscribe [::required-party-roles phase-id])])
  (fn [[unlocked required] _]
    (set/difference unlocked required)))

(rf/reg-sub ::can-add-role-requirement?
  (fn [[_ phase-id]]
    [(rf/subscribe [::process/signal-permitted? phase-id [:process.signal/add-party-role-requirement]])
     (rf/subscribe [::unrequired-party-roles phase-id])])
  (fn [[permitted? roles-to-choose] _]
    (boolean (and permitted?
                  (seq roles-to-choose)))))

(rf/reg-sub ::unrequired-party-roles-sorted
  (fn [[_ phase-id]]
    [(rf/subscribe [::unrequired-party-roles phase-id])
     (rf/subscribe [:language])])
  (fn [[unused-roles lang] _]
    (->> unused-roles
         (map (fn [role]
                {:label (role-model/party-role-name role lang)
                 :id    (:db/id role)}))
         (sort-by :label))))

(rf/reg-event-fx ::add-role-requirement-clicked
  (fn [{:keys [db]} [_ data]]
    {:db (assoc-in db [::party-role-modal-data :add] data)}))

(rf/reg-event-fx ::remove-role-requirement-clicked
  (fn [{:keys [db]} [_ data]]
    {:db (assoc-in db [::party-role-modal-data :remove] data)}))

(rf/reg-sub ::party-role-modal-data
  :-> ::party-role-modal-data)

(rf/reg-sub ::party-role-modal-add-data
  :<- [::party-role-modal-data]
  :-> :add)

(rf/reg-sub ::party-role-modal-remove-data
  :<- [::party-role-modal-data]
  :-> :remove)

(rf/reg-sub ::show-add-party-role-req-modal?
  :<- [::party-role-modal-data]
  :-> (comp some? :add))

(rf/reg-sub ::show-remove-party-role-req-modal?
  :<- [::party-role-modal-data]
  :-> (comp some? :remove))

(rf/reg-event-fx ::close-requirement-modal-clicked
  (fn [{:keys [db]} _]
    {:db (dissoc db ::party-role-modal-data)}))

(rf/reg-sub ::enriched-party-role-requirements
  (fn [[_ phase-id]]
    [(rf/subscribe [:language])
     (rf/subscribe [::party-role-requirements phase-id])
     (rf/subscribe [::party-subs/parties phase-id])])
  (fn [[lang requirements parties] _]
    (->> requirements
         (map (fn [{:requirement/keys [party-role] :as requirement}]
                (let [fulfilled?   (->> parties
                                        (filter (fn [party]
                                                  (contains? (entities/get-id party :party/party-roles)
                                                             (entities/get-id requirement :requirement/party-role))))
                                        seq)
                      border-color (if fulfilled?
                                     "border-ui-green"
                                     "border-ui-red-100")]
                  (merge (select-keys requirement [:db/id :requirement/party-role
                                                   :requirement/review :entity/created])
                         {:requirement/border-color border-color
                          :requirement/title        (role-model/party-role-name party-role lang)}))))
         (sort-by :requirement/title))))

(rf/reg-sub ::find-requirement-by-party-role
  (fn [[_ phase-id _]]
    (rf/subscribe [::party-role-requirements phase-id]))
  (fn [requirements [_ _ target-party-role-id]]
    (->> requirements
         (filter (fn [{:requirement/keys [party-role]}]
                   (= (:db/id party-role) target-party-role-id)))
         first
         :db/id)))
